// Get all elements with the class 'eu-size' and add click event listener
document.querySelectorAll('.eu-size').forEach(function (element) {
    element.addEventListener('click', function () {
        getValue(this);
    });
});

// Get all elements with the class 'uk-size' and add click event listener
document.querySelectorAll('.uk-size').forEach(function (element) {
    element.addEventListener('click', function () {
        getValue(this);
    });
});

// Get all elements with the class 'eu-size-value'
const euElements = document.querySelectorAll('.eu-size-value');


// Get all elements with the class 'uk-size-value'
const ukElements = document.querySelectorAll('.uk-size-value');

function getValue(clickedButton) {
    // Remove 'active' class from all buttons initially
    document.querySelectorAll('.eu-size, .uk-size').forEach(function (button) {
        button.classList.remove('btn--primary');
    });

    // Add 'active' class to the clicked button
    clickedButton.classList.add('btn--primary');

    // Get the text content of the clicked button
    var buttonText = clickedButton.textContent;


    // Hide all elements initially
    euElements.forEach(function (element) {
        element.style.display = 'none';
    });

    ukElements.forEach(function (element) {
        element.style.display = 'none';
    });

    // Display the corresponding elements based on the clicked button
    if (buttonText === 'UK') {
        ukElements.forEach(function (element) {
            element.style.display = 'block';
        });
    } else {
        euElements.forEach(function (element) {
            element.style.display = 'block';
        });
    }
}
